import React from 'react';
import { SketchPad } from '../modules/sketchPad/sketchpad';

/** use to draw new annotation */
export const DrawingCanvasContext = React.createContext<{
  sketchPad: SketchPad;
}>({
  sketchPad: null
});
